import React, { useState } from "react";
import axios from "axios";


const useCRUDController = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
    apiRoute = ""
}) => {
    const [data, setData] = useState([])
    const [extendResponseData, setExtendResponseData] = useState([])
    const getData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(apiRoute, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                // setData()
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(apiRoute,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(apiRoute,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(apiRoute,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const exportData = (data) => {
        onBefore({
            axiosMode: "export"
        })
        axios.get(`${apiRoute}_export/excel`,
            {
                responseType: 'blob',
                params: data,
            },
        )
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯出清單.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "export",
                        status: "success"
                    }
                )
            })
    }
    const importData = (data) => {
        onBefore({
            axiosMode: "import"
        })
        const files = data.target.files[0];
        let form_data = new FormData();
        form_data.append('inputFile', files);
        form_data.append('language', data?.choose_column);
        form_data.append('default_column', JSON.stringify(data?.columns));
        axios
            .post(`${apiRoute}_import/read_sample`, form_data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                setExtendResponseData(responseData.data)

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    const downloadData = () => {
        onBefore({
            axiosMode: "download_sample"
        })
        axios
            .get(`${apiRoute}_import/manual`, {
                responseType: 'blob',
            })
            .then((response) => {
                let responseData = response.data
                const downloadUrl = window.URL.createObjectURL(new Blob([responseData]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', '匯入範例.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                setExtendResponseData(responseData)
                onFinish(
                    {
                        axiosMode: "download_sample",
                        status: "success"
                    }
                )
            })
    }
    const overData = (data) => {
        onBefore({
            axiosMode: "over"
        })
        axios
            .post(`${apiRoute}_import/over_data`, data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status

                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "import",
                            status: "success"
                        }
                    )
                }
            })
    }
    return {
        ResponseData: data,
        ExtendResponseData: extendResponseData,
        getData,
        postData,
        patchData,
        deleteData,
        exportData,
        importData,
        downloadData,
        overData,
    }
}
export { useCRUDController }
